var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"pl-8 mb-8",attrs:{"color":"primary","text":"","max-width":"600"}},[_c('ressource',{attrs:{"code":"domicile_professionnel"}}),_c('div',{staticClass:"mt-3"},[_vm._v(" "+_vm._s(_vm.domicileProfessionnel)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }